module.exports = __webpack_public_path__ + "static/media/authenticate.26e8acf5.jpg";